import { Component, Input, OnInit } from "@angular/core";
import { Development, legendColorCollection } from "@models/development.model";
import Chart, { Color } from "chart.js/auto";
import { pieChartTitle, pieChartColor, chartFontFamily } from "src/app/constants/charts-const";
import ChartDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: "app-pie-chart",
  templateUrl: "./pie-chart.component.html",
  styleUrls: ["./pie-chart.component.scss"],
})
export class PieChartComponent implements OnInit {
  @Input() development!: Development;
  pieChart: any;

  chartLegends: legendColorCollection[] = [];

  twentyYearProjectBudget = 0;

  ngOnInit(): void {
    this.getChartLables();
    this.createPieChart();
  }

  createPieChart() {
    // console.log(this.development.areasOfWork.flatMap((x) => Math.round(x.twentyYearCapitalNeeds)));

    this.pieChart = new Chart("pieChart", {
      type: "pie",
      data: {
        labels: this.development.areasOfWork.flatMap((x) => x.name),
        datasets: [
          {
            label: "",
            data: this.development.areasOfWork.flatMap((x) => Math.round(x.twentyYearCapitalNeeds)),
            backgroundColor: this.chartLegends.flatMap((x) => x.colorCoding),
            datalabels: {
              color: this.getChartlabelColor(),
              padding: { bottom: 50 },
              textAlign: "start",
              font: {
                weight: "bolder",
                size: 14,
              },
            },
            hoverOffset: 4,
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        plugins: {
          title: pieChartTitle,
          legend: {
            position: "bottom",
            display: false,
            labels: {
              color: "#000000",
              boxWidth: 12,
              font: {
                size: 12,
                weight: "bolder",
                family: chartFontFamily,
              },
            },
          },
          datalabels: {
            display: true,
            formatter: (value, context) => {
              return (value / this.getTwentyYearProjectBudget()) * 100 >= 0 &&
                (value / this.getTwentyYearProjectBudget()) * 100 < 5
                ? "   "
                : Math.floor((value / this.getTwentyYearProjectBudget()) * 100) + "%";
            },
            // padding: { bottom: 500 },
            anchor: "center",
            // align: "left",
            // offset: 50,
            font: {
              size: 12,
              family: chartFontFamily,
            },
          },
        },

        scales: {
          y: {
            display: false,
            grid: {
              display: false,
            },
          },
          x: {
            display: false,
            grid: {
              display: true,
            },
          },
        },
        aspectRatio: window.innerWidth <= 1280 ? 1.7 : 1.8,
      },
    });
  }

  getTwentyYearProjectBudget(): number {
    if (this.twentyYearProjectBudget === 0) {
      this.twentyYearProjectBudget = this.development.areasOfWork
        .flatMap((x) => x.twentyYearCapitalNeeds)
        .reduce((acc, cur) => acc + Number(cur), 0);
      return this.twentyYearProjectBudget;
    } else {
      return this.twentyYearProjectBudget;
    }
    // return this.development.areasOfWork
    //   .flatMap((x) => x.twentyYearCapitalNeeds)
    //   .reduce((acc, cur) => acc + Number(cur), 0);
  }

  getChartlabelColor(): Color[] {
    const chartColor: Color[] = [];
    this.development.areasOfWork
      .flatMap((x) => Math.round(x.twentyYearCapitalNeeds))
      .forEach((value) => {
        chartColor.push(
          (value / this.getTwentyYearProjectBudget()) * 100 > 0 &&
            (value / this.getTwentyYearProjectBudget()) * 100 < 1
            ? "#000000"
            : "#FFFFFF",
        );
      });
    return chartColor;
  }

  getChartLables() {
    this.chartLegends.push({
      legendName: this.getSliceValue("Roofs"),
      colorCoding: "rgba(79, 121, 98, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Building Exteriors/Facades/Windows"),
      colorCoding: "rgba(98, 166, 157, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Heating"),
      colorCoding: "rgba(46, 107, 52, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Elevators"),
      colorCoding: "rgba(97, 143, 139, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Waste Management"),
      colorCoding: "rgba(26, 67, 32, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Interior Electrical/Lighting"),
      colorCoding: "rgba(62, 119, 109, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Plumbing"),
      colorCoding: "rgba(124, 192, 165, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Safety And Security"),
      colorCoding: "rgba(116, 123, 124, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Apartments"),
      colorCoding: "rgba(103, 165, 119, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Common Areas/Lobbies"),
      colorCoding: "rgba(98, 156, 169, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Grounds"),
      colorCoding: "rgba(9, 126, 152, 1)",
    });
    this.chartLegends.push({
      legendName: this.getSliceValue("Other"),
      colorCoding: "rgba(37, 89, 136, 1)",
    });
  }

  private getSliceValue(legendName: string): string {
    let percent = 0;
    const areaofwork = this.development.areasOfWork.find(
      (x) => x.name.toLocaleLowerCase() === legendName.toLocaleLowerCase(),
    );
    if (areaofwork) {
      percent = Math.floor(
        (areaofwork.twentyYearCapitalNeeds / this.getTwentyYearProjectBudget()) * 100,
      );
    }
    return legendName + " - " + percent + "%";
  }
}
